import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import { Plugin, Fragment } from 'vue-fragment';
import i18n from '@/i18n';
import http from '@/http';
import PortalVue from 'portal-vue';
import dayjs from 'dayjs';
import pluralize from 'pluralize';
import { makeServer } from '@/server';
import { notification, Card } from 'ant-design-vue';
import relativeTime from 'dayjs/plugin/relativeTime';
import Dinero from 'dinero.js';
dayjs.extend(relativeTime);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'development' && process.env.FAKE_SERVER) {
    makeServer();
}

notification.config({
    placement: 'bottomRight',
});

const formatDate = value => {
    if (!value) {
        return null;
    }

    return dayjs(value).format(i18n.t('dateFormat'));
};

const formatDateTime = value => {
    if (!value) {
        return null;
    }

    return dayjs(value).format(i18n.t('dateTimeFormat'));
};
const formatFrom = value => {
    if (!value) {
        return null;
    }

    return dayjs(value).fromNow();
};
const formatMoney = value => {
    if (value === null || value === '') {
        return null;
    }

    return Dinero({ amount: parseInt(value, 10), currency: 'EUR' })
        .setLocale('nl-NL')
        .toFormat('$0,0.00');
};


Vue.use(Plugin);
Vue.use(PortalVue);
Vue.component('Fragment', Fragment);
Vue.component('Card', Card);
Vue.prototype.$theme = process.env.VUE_APP_THEME;
Vue.prototype.$endpoint = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_BASE_PATH;
Vue.prototype.$http = http;
Vue.prototype.$singular = pluralize.singular;
Vue.prototype.$plural = pluralize.plural;
Vue.prototype.$notification = notification;
Vue.prototype.$formatDate = formatDate;
Vue.prototype.$formatDateTime = formatDateTime;
Vue.prototype.$formatFrom = formatFrom;
Vue.prototype.$formatMoney = formatMoney;
Vue.prototype.$writeToClipboard = (value) => navigator.clipboard.writeText(value);

Vue.filter('dateTime', formatDateTime);
Vue.filter('date', formatDate);
Vue.filter('from', formatFrom);
Vue.filter('money', formatMoney);

new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
